import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface Step {
  id: string
  name: string
}

export const IntegrationWarningModal = ({
  open,
  onClose,
  integrationSteps,
}: {
  open: boolean
  onClose: () => void
  integrationSteps: Step[]
}) => {
  const { t } = useTranslation('requests')

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('pause.integration-warning-modal.heading')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('pause.integration-warning-modal.text')}</DialogContentText>
        <Stack component="ul" sx={{ my: 2, pl: 3 }}>
          {integrationSteps.map((step) => (
            <DialogContentText key={step.id} component="li">
              {step.name}
            </DialogContentText>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="neutral" onClick={onClose}>
          {t('pause.integration-warning-modal.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
